import axios from "axios";

// Global axios interceptor: attaches the auth token (if present) to every
// outgoing request, so individual pages/components don't need to set it
// themselves. Importing this file once (see src/index.js) is enough since
// axios keeps a single shared instance across the app.
axios.interceptors.request.use(
    (config) => {
        const authToken = sessionStorage.getItem("token");

        if (authToken) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Token ${authToken}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export default axios;
